import { render, staticRenderFns } from "./shen.vue?vue&type=template&id=6fc53c60&scoped=true&"
import script from "./shen.vue?vue&type=script&lang=js&"
export * from "./shen.vue?vue&type=script&lang=js&"
import style0 from "./shen.vue?vue&type=style&index=0&id=6fc53c60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc53c60",
  null
  
)

export default component.exports